
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { isNullOrUndefined } from 'util';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import { PresetImportarExcel } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.nav';
import { IColumna } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.lib';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        @Prop()
        public Columnas: IColumna[];

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = this.Abrir;
            if ( this.Abierto )
            {
                this.$nextTick( () =>
                {
                    if ( this.Columnas.hasRows() )
                    {
                        this.Predefinida = new PresetImportarExcel();
                        this.Predefinida.Columnas = this.Columnas;
                        this.Abierto = true;
                    }
                } );
            }

        }

        public Predefinida: PresetImportarExcel = null;
        public Abierto: boolean = false;
        public Cargando: boolean = false;

        public get Ok()
        {
            return !isNullOrUndefined( this.Predefinida ) &&
                this.Predefinida.Columnas.hasRows() &&
                this.Predefinida.Nombre  &&
                this.Predefinida.Color;
        }

        async Guardar()
        {
            if ( this.Predefinida )
            {
                this.Cargando = true;
                let e = await this.Predefinida.save();
                if ( e )
                {
                    await Wait(100);
                    Utiles.Notificaciones.Completado( 'Guardado correctamente!' );
                    this.Cerrar();
                } else
                {
                    Utiles.Notificaciones.Error( 'Error al guardar' );
                }
            }
            this.Cargando = false;
        }

        Cerrar()
        {
            this.$emit( 'recargar' );
            this.Predefinida = null;
            this.Abierto = false;
        }
    }
